module.exports = __webpack_public_path__ + "static/img/5.8b4f67a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/zh/5.png
// module id = jK9L
// module chunks = 0